<template>
    <div>
        <div class="casino-game-slider">
            <swiper v-if="!loading" :options="swiperOptionGame">
                <swiper-slide @click.native="run" v-for="(item,key) in sliders" :key="key">
                    <router-link :to="'/' + item.url">
                    <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                    </router-link>
                </swiper-slide>
            </swiper>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props:['isLoadingParent','inPlay'],
    data() {
      return {
        loading:false,
        swiperOptionGame: {
            lazy: true,
            speed: 1500,
            slidesPerView: !this.isMobile ? 5 : 3,
            spaceBetween: 20,
            autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            },
        },
        sliders:[],
      }
    },
    watch:{
        isLoadingParent(val){
            if(!val){
                this.setSwiper()
            }
        },
        inPlay(val){
            if(!val){
                this.setSwiper()
            }
        }
    },
    created(){
      this.fetchData();
    },
    methods:{
      run(){
          setTimeout(() => {
            this.$store.dispatch('slot/runGame', { id: this.$route.query.game_id, device: this.$route.query.mobile });
          }, 500);
      },
      setSwiper(){
        this.loading = true
        setTimeout(() => {
            this.swiperOptionGame = {
            lazy: true,
            speed: 1500,
            slidesPerView: !this.isMobile ? 5 : 3,
            spaceBetween: 20,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                },
            }
            this.loading = false
        }, 500);
      },
      fetchData(){
        this.loading = true
        this.$store.dispatch('getBanner', ['slot', 'desktop', 'top'])
        .then(response =>{
          this.sliders  	= _.sortBy(response.data, ['sort']);
          this.setSwiper();
        });
      }
    },
  }
  </script>

<style>
  #app.mobile .casino-game-slider{
    padding: 0 20px;
  }
</style>